import { z } from "zod";
import { canvasElementBaseSchema } from "./canvas-element";
import { textEnabledSchema } from "./text-enabled-schema";

const textEnabledSchemaInternal = textEnabledSchema.merge(canvasElementBaseSchema);

export type TextEnabledElement = z.infer<typeof textEnabledSchemaInternal>;
